import { api } from 'domains/api';
import { BASE_ANONYMOUS_API_ROUTES, getBaseAPIRoute } from 'domains/api/base/routes';
import { PartialRescheduleClientInformation, Reschedule } from './types';

export const getReschedule = (clientId: string, rescheduleId: string): Promise<Reschedule> => {
  return api.baseAnonymous.get<Reschedule>(
    getBaseAPIRoute(BASE_ANONYMOUS_API_ROUTES.clients[':clientId']['pending-reschedules'][':rescheduleId'].get, {
      rescheduleId,
      clientId,
    }),
  );
};

export const getPartialRescheduleClientInformation = (clientId: string): Promise<PartialRescheduleClientInformation> => {
  return api.baseAnonymous.get<PartialRescheduleClientInformation>(
    getBaseAPIRoute(BASE_ANONYMOUS_API_ROUTES.clients[':clientId']['reschedule-info'], {
      clientId,
    }),
  );
};

export type ReschedulePendingRescheduleDto = {
  dateTime: string;
  timeZone: string;
  calendarID?: number;
};

export const reschedulePendingReschedule = (
  clientId: string,
  rescheduleId: string,
  payload: ReschedulePendingRescheduleDto,
): Promise<Reschedule> => {
  return api.baseAnonymous.post(
    getBaseAPIRoute(BASE_ANONYMOUS_API_ROUTES.clients[':clientId']['pending-reschedules'][':rescheduleId'].reschedule, {
      rescheduleId,
      clientId,
    }),
    payload,
  );
};
